import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Modal, Spacer, Spinner, Typography } from '@telus-uds/components-web';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button as ActionButton } from './css';

const SendToSrt = ({ orderData, fetchOrders }) => {
  const { id, sendToSRT } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, sendToSrtLabel },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSendToSrt = () => {
    const body = {
      sendToSRT: true
    };
    setIsLoading(true);
    request.put(`/orders/${id}`, body).then(() => {
      setIsLoading(false);
      fetchOrders();
      setIsModalOpen(false);
    });
  };

  if (sendToSRT) return null;

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Requesting..."
        show={isLoading}
      />
      <ActionButton className="action-button" onClick={() => setIsModalOpen(true)}>
        {sendToSrtLabel}
      </ActionButton>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <Typography variant={{ size: 'h2' }}>{confirmationDialog}</Typography>
        <Spacer space={1} />
        <p>Are you sure you want to send this order to SRT Group?</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'low' }}
            onPress={() => setIsModalOpen(false)}
          >
            {cancelButtonLabel}
          </Button>
          <Button
            type="button"
            variant={{ priority: 'high' }}
            onPress={handleSendToSrt}
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

SendToSrt.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default SendToSrt;
